var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.toastCreated)?_c('div',{staticClass:"ed-toast-msg",style:({ top: _vm.props.top }),attrs:{"showing":_vm.isShowing,"type":_vm.type}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.msg)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }